module.exports = __webpack_public_path__ + "static/logo-white-549ed6a55e10decc3dee1c37ae70115a.svg";